export const errorHasNonZeroResponseCode = (error: unknown, isNumberZero: boolean = false): boolean => {
    //@ts-ignore
    console.log(error.responseData?.responseCode);
    console.log(error)
    //@ts-ignore
    return error.responseData?.responseCode !== (isNumberZero ? 0 : "0");
};
